import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';

export enum RouteNames {
  Home = 'Home',
  Camera = 'Camera',
  Embed = 'Embed',
  Error = 'Error',
  Terms = 'Terms',
  UserData = 'UserData',
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: RouteNames.Home,
    component: Home,
  },
  {
    path: '/camera',
    name: RouteNames.Camera,
    component: () => import('../views/Camera.vue'),
  },
  {
    path: '/record/answer',
    name: RouteNames.Embed,
    component: () => import('../views/Embed.vue'),
  },
  {
    path: '/error',
    name: RouteNames.Error,
    component: () => import('../views/Error.vue'),
    props: true,
  },
  {
    path: '/terms',
    name: RouteNames.Terms,
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/user-data',
    name: RouteNames.UserData,
    component: () => import('../views/UserData.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
